import {
  CSSProperties,
  StyleDeclarationMap,
  StyleSheet,
} from '../../../styleSheet';

type GlobalStyle = {
  [key in 'default']?: CSSProperties | StyleDeclarationMap;
};

export const injectGlobalStyle = (styles: GlobalStyle): void => {
  const globalSelectorHandler = (
    selector: string,
    _baseSelector: string,
    callback: (selector: string) => string,
  ) => {
    if (selector[0] !== '*') {
      return null;
    }
    return callback(selector.slice(1));
  };

  const globalExtension = {selectorHandler: globalSelectorHandler};
  const extended = StyleSheet.extend([globalExtension]);
  const s = extended.StyleSheet.create(styles);
  extended.css(s.default);
};
